/**
 * Katalog Kodu (Ürün Açıklaması) formatlayıcı.
 * Harf ve rakam gruplarını ayırır, özel kod gruplarını (F18, D2OR vb.) birleştirir.
 * @param {string} text 
 * @returns {string} Formatlanmış metin
 */
export const formatKatalogKodu = (text) => {
    if (!text) return "";
    
    // Boşluk karakterlerine göre split ederek 0. elemanı (esas katalog kodunu) alırız.
    // Bu sayede TEKSTIL, FRENLI vb. sonradan eklenmiş açıklamaları temizlemiş oluruz.
    const cleanCode = text.split(/[\s\xa0]+/)[0];
    
    return cleanCode
        .replace(/([a-zA-Z]+)|(\d+)/g, "$1$2 ") // Harf ve rakamları ayır
        .trim()
        .replace(/\s+/g, ' ') // Fazla boşlukları temizle
        .replace(/\bF\s(\d{2})\b/g, "F$1") // F + 2 rakam birleştir (Örn: F 18 -> F18)
        .replace(/\bD\s2\sOR\b/g, "D2OR") // D + 2OR birleştir (Örn: D 2 OR -> D2OR)
        .replace(/\bK\s2\sOR\b/g, "K2OR"); // K + 2OR birleştir (Örn: K 2 OR -> K2OR)
};

/**
 * Orjinal kodun devamındaki açıklamaları ayıklar.
 * @param {string} text 
 * @returns {{ code: string, description: string }}
 */
export const parseOriginalCode = (text) => {
    if (!text) return { code: "", description: "" };
    
    // Trim the input text
    const trimmed = text.trim();
    
    // Match standard code patterns at the start: e.g. 4102-055-415 or similar.
    // Typically: digits, hyphens, and sometimes a trailing alphanumeric suffix,
    // followed by spaces, parentheses, slashes, or dashes and description.
    const match = trimmed.match(/^(\d+-\d+-\d+(?:-[A-Za-z0-9]+)?)(.*)$/);
    
    if (match) {
        let code = match[1].trim();
        let desc = match[2].trim();
        
        // Clean up description prefixes like ' - ', ' / ', or outer parentheses
        desc = desc.replace(/^[-/\s()]+/, '').replace(/[()]+$/, '').trim();
        
        return { code, description: desc };
    }
    
    return { code: trimmed, description: "" };
};
